import React from "react";
import { useState,useEffect,useRef } from "react";
import { useParams,useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './classes/SalesReportByProduct.css';
import { DataGrid } from '@mui/x-data-grid';
import { configData } from "../config";
import { Link } from '@mui/material';
import Loading from './Loading';
import { format } from "date-fns";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';



const columns = [
   
    {
        field: 'order_id',
        headerName: 'Order ID',
        cellClassName:'order_id_column',headerClassName:'order_id_header',  
        flex:1, 
        // minWidth: 70, 
        sortable:false,
    },
     {
        field: 'first_name',
        headerName: 'First Name',
        cellClassName:'first_name_column',headerClassName:'first_name_header',  
        flex:1, 
        // minWidth: 98, 
        sortable:false,
    },
     {
        field: 'last_name',
        headerName: 'Last Name',
        cellClassName:'last_name_column',headerClassName:'last_name_header',  
        flex:1, 
        // minWidth: 71, 
        sortable:false,
    },
        {
        field: 'email',
        headerName: 'Email',
        flex:2.25,
        sortable: false,
        // minWidth:230,
        cellClassName:'email_column',headerClassName:'email_header', 
         renderCell: (params) => (
        <Link href={params.row.view_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
            {params.row.email}
          </Link>
      ),
        
      },
      {
        field: 'country',
        headerName: 'Country',
        cellClassName:'country_column',headerClassName:'country_header',  
        flex:1, 
        // minWidth: 88, 
        sortable:false,
    },
    {
        field: 'salesperson',
        headerName: 'Salesperson',
        cellClassName:'salesperson_column',headerClassName:'salesperson_header',  
        flex:1, 
        // minWidth: 87, 
        sortable:false,
    },
    {
        field: 'products_purchased',
        headerName: 'Product Purchased',
        cellClassName:'product_purchased_column',headerClassName:'product_purchased_header',  
        flex:1.5, 
        // minWidth: 180, 
        sortable:false,
    },
    {
        field: 'amount',
        headerName: 'Amount Paid',
        cellClassName:'amount_paid_column',headerClassName:'amount_paid_header',  
        flex:1, 
        // minWidth: 90, 
        sortable:false,
    },
    {
        field: 'sales_amount',
        headerName: 'Sales Amount',
        cellClassName:'sales_amount_column',headerClassName:'sales_amount_header',  
        flex:1, 
        // minWidth: 90, 
        sortable:false,
    },
    {
        field: 'ship_amount',
        headerName: 'Shipping Amount',
        cellClassName:'shipping_amount_column',headerClassName:'shipping_amount_header',  
        flex:1, 
        // minWidth: 69, 
        sortable:false,
    },
    {
        field: 'payment_date',
        headerName: 'Payment Date',
        cellClassName:'payment_date_column',headerClassName:'payment_date_header',  
        flex:1, 
        // minWidth: 100, 
        sortable:false,
    },
    {
        field: 'payment_method',
        headerName: 'Payment Method',
        cellClassName:'payment_method_column',headerClassName:'payment_method_header',  
        flex:1, 
        // minWidth: 67, 
        sortable:false,
    },
   
  
];




const SalesReportByProduct = () => { 



    // const initialForm = {
        
    //     courses:[],        
    //     start_date:'',
    //     end_date:'',
    //     start_date_obj:null,
    //     end_date_obj:null,
    //     payment_method:'All'
        
    // };
    
  // useEffect(() => {
  //   const params = new URLSearchParams(window.location.search);
  //   const reportViewId = params.get("report_view_id");

  //   if (!reportViewId) return; // do nothing if not present

  //   const fetchData = async () => {
  //     try {
  //       const res = await fetch(app_url+'report/getreportfilters', {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({
  //           id: reportViewId, 
  //         }),
  //       });

  //       const data = await res.json();
  //       // console.log(data);
  //       setAppliedFormData(data.data.params);
  //     } catch (err) {
  //       console.error(err);
  //     }
  //   };

  //   fetchData();
  // }, []);
    
  const initialForm = () => {
  const params = new URLSearchParams(window.location.search);

  const defaultForm = {
    courses:[],
    start_date:'',
    end_date:'',
    start_date_obj:null,
    end_date_obj:null,
    payment_method:'All',
    action: '',
  };

  //  normal dates
  const queryStart = params.get("start_date");
  const queryEnd = params.get("end_date");

  // const startObj = queryStart && !isNaN(new Date(queryStart))
  //   ? new Date(queryStart + "T00:00:00")
  //   : null;

  // const endObj = queryEnd && !isNaN(new Date(queryEnd))
  //   ? new Date(queryEnd + "T00:00:00")
  //   : null;
  const startObj =
    queryStart
      ? new Date(queryStart.replace(/-/g, "/") + " 00:00:00")
      : null;

  const endObj =
    queryEnd
      ? new Date(queryEnd.replace(/-/g, "/") + " 00:00:00")
      : null;

  // const courses = params.has("courses")
  //   ? params.getAll("courses").length
  //     ? params.getAll("courses") 
  //     : params.get("courses").split(",") // Comma-separated values (convert to array)
  //   : defaultForm.courses;
// const courses = (() => {
//         if (!params.has("courses")) return [];

//         const allCourses = params.getAll("courses");

//         if (allCourses.length > 1) {
//             return allCourses.filter(Boolean); 
//         }

//         if (allCourses.length === 1) {
//             if (!allCourses[0]) return []; 

//             return allCourses[0]
//             .split(",")
//             .filter(Boolean); 
//         }

//         return [];
//         })();
     const courses = (() => {
        const values = [];

        for (const [key, value] of params.entries()) {
            if (key.startsWith("courses[")) {
            if (value) values.push(value);
            }
        }

        return values;
        })();

  return {
    ...defaultForm,
    // courses: params.get("courses") || defaultForm.courses,
    courses: courses,
    payment_method: params.get("payment_method") || defaultForm.payment_method,

    //  normal dates
    start_date: startObj ? queryStart : '',
    start_date_obj: startObj,

    end_date: endObj ? queryEnd : '',
    end_date_obj: endObj,

    action: '',
  };
};   


    const [isLoading, setIsLoading] = useState(true);
    const [formData, setFormData] = useState(initialForm());
    const [appliedFormData, setAppliedFormData] = useState(initialForm());
    const [submittedData, setSubmittedData] = useState(null); 
    const [formErrors, setFormErrors] =useState({}); 
    const [rows, setRows] = React.useState([]);
    const [rowCount, setRowCount] = React.useState(0);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = React.useState([]);
    const [filterModel, setFilterModel] = React.useState({ items: [] });
    const navigate = useNavigate();
    const[courseList, setCourseList] = useState({});
    const app_url = configData.APP_URL;
    const[totalAmount, setTotalAmount] = useState(0);
    const[totalSaleAmount, setTotalSaleAmount] = useState(0);
    const[totalShipAmount, setTotalShipAmount] = useState(0);
    const startDateRef = useRef(null);
    const endDateRef = useRef(null);
    const [isSubmitted, setIsSubmitted] = useState(false);    
    
  // const handleDateChange = (name, date) => {
  //   const formattedDate = date ? format(date, "yyyy-MM-dd") : "";
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: formattedDate
  //   }));
  // };
  const handleDateChange = (date, field) => {
  setFormData(prev => ({
    ...prev,
    [`${field}_obj`]: date,                       // for DatePicker
    [field]: date ? format(date, 'yyyy-MM-dd') : '' // for backend
  }));
};
  const handleCoursesChange = (e) => {
        const selectedValues = Array.from(e.target.selectedOptions, opt => opt.value);
        setFormData(prev => ({ ...prev, courses: selectedValues }));
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    useEffect(() => { 
        
        Promise.all([
         getcourselist()
          
          ]).then(() => {
            setIsLoading(false);
            
          })
     
    },[]); 

   React.useEffect(() => {
             if(formData.start_date && formData.end_date) {
                 const fetchData = async () => {
                 // Simulate API call to your server
                  // In a real application, replace this with your actual fetch logic
            try {
             setIsLoading(true);
           const response = await fetch(app_url+'salesreportbyproduct/getlist', {
             method: 'POST',
             headers: { 'Content-Type': 'application/json' },
             body: JSON.stringify({
               page: paginationModel.page,
               pageSize: paginationModel.pageSize,
               sortModel,
               filterModel,
              //  formData:appliedFormData
                formData: {
                  ...appliedFormData,
                  action: isSubmitted ? 'submit' : ''
                }
             }),
           });
           const data = await response.json();
           console.log(data.data.rows);
           setRows(data.data.rows);
           setRowCount(data.data.totalRowCount); // Server should return totalRowCount
           setTotalAmount(data.data.totalpayment);
           setTotalSaleAmount(data.data.totalsaleamount);
           setTotalShipAmount(data.data.totalshipamount);
           }  catch (error) {
                 console.error('Error fetching data:', error);
               } finally {
                  setIsLoading(false); // Set loading to false after fetch completes (success or error)
                  if (isSubmitted) {
                    setIsSubmitted(false);
                  }
               }
               
         };
         
     
         fetchData();
       }
           }, [paginationModel, sortModel, filterModel, appliedFormData]); // Re-fetch data when these change 
           const validateDates = (formData) => {
  let errors = {};

  if (!formData.start_date) {
    errors.start_date = "Start date is required.";
  }

  if (!formData.end_date) {
    errors.end_date = "End date is required.";
  }

  if (formData.start_date && formData.end_date) {
    if (formData.end_date < formData.start_date) {
      errors.end_date = "Start date can't over end date.";
    }
  }

  return errors;
};

const submitFormData = async (data) => {
  setSubmittedData(data);
  setAppliedFormData(data);
  setIsSubmitted(false);
};
     
         const handleSubmit = async (e) => {
             e.preventDefault(); // stop page reload
                 const errors = validateDates(formData);

  if (Object.keys(errors).length > 0) {
    console.log("Validation errors:", errors);
    setFormErrors(errors); 
    return;
  }
   setFormErrors({});
             setSubmittedData(formData);
             // Reset pagination state
                setPaginationModel({
                 page: 0,
                    pageSize: 50,
                 });
    setSubmittedData(formData);
    setAppliedFormData({...formData});
    setIsSubmitted(true);
          // try {
          //    setIsLoading(true);
          //  const response = await fetch(app_url+'salesreportbyproduct/getlist', {
          //    method: 'POST',
          //    headers: { 'Content-Type': 'application/json' },
          //    body: JSON.stringify({
          //      page: 0,
          //      pageSize: 50,
          //      sortModel,
          //      filterModel,
          //      formData:formData
          //    }),
          //  });
          //  const data = await response.json();
         
          //  setRows(data.data.rows);
          //  setRowCount(data.data.totalRowCount); // Server should return totalRowCount
          //  setTotalAmount(data.data.totalpayment);
          //  setTotalSaleAmount(data.data.totalsaleamount);
          //  setTotalShipAmount(data.data.totalshipamount);
           
          //  }  catch (error) {
          //        console.error('Error fetching data:', error);
          //      } finally {
          //        setIsLoading(false); // Set loading to false after fetch completes (success or error)
          //      }
        
         
         };
  async function getcourselist() {
        try {
            const response = await fetch(
                app_url+'smwwcommerceproduct/getsalesreportbyproductlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setCourseList(responsedata.data.result);
                
               
            } 
        } catch (err) {
            
        }    
    }
  const handleExport = async (e) => {
    e.preventDefault(); // stop page reload
        const errors = validateDates(formData);

  if (Object.keys(errors).length > 0) {
    console.log("Validation errors:", errors);
    setFormErrors(errors); 
    return;
  }
   setFormErrors({});
   
     try {
        setIsLoading(true);
      const response = await fetch(app_url+'salesreportbyproduct/getexport', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          
          formData:formData
        }),
      });
      const data = await response.json();
      const csvUrl = data.data.csvUrl;
      const urlParts = csvUrl.split('/');
        const fileName = urlParts[urlParts.length - 1];
                const link = document.createElement('a');
                link.href = csvUrl;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
      
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }


  };
     const handleReset = async () => {
   window.location.reload();
  };

  // useEffect(() => {
  //   const params = new URLSearchParams(window.location.search);

  //   if ([...params.keys()].length > 0) {
  //     const init = initialForm();

  //     setFormData(init);

  //     submitFormData(init);              
  //   }
  // }, []);
const normalizeBackendData = (backendParams) => {
  return {
    ...backendParams,

    start_date_obj: backendParams.start_date
      ? new Date(backendParams.start_date.replace(/-/g, "/") + " 00:00:00")
      : null,

    end_date_obj: backendParams.end_date
      ? new Date(backendParams.end_date.replace(/-/g, "/") + " 00:00:00")
      : null,
  };
};

useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const reportViewId = params.get("report_view_id");

  const baseForm = initialForm(); 

  if (reportViewId) {
    const fetchData = async () => {
      try {
        const res = await fetch(app_url + 'report/getreportfilters', {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: reportViewId }),
        });

        const data = await res.json();
        const backendParams = data?.data?.params || {};

        //  normalize backend
        const normalized = normalizeBackendData(backendParams);

        //  merge (backend overrides URL/defaults)
        const finalData = {
          ...baseForm,
          ...normalized,
        };

        setFormData(finalData);
        submitFormData(finalData);

      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  } else {
    //  fallback → only URL/default
    if ([...params.keys()].length > 0) {
      setFormData(baseForm);
      submitFormData(baseForm);
    }
  }

}, []);

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : ( 
                <div id="main" className="sales-report-byproduct-main">
                    <Helmet><title>Sales Report By Product</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="sales-report-byproduct-container">
                        <h1>Sales Report By Product</h1>
                       <div className="messages warning">
                            <strong>This report includes:</strong><br/>

                            &nbsp;&nbsp;- Courses Payments<br/>
                            &nbsp;&nbsp;- Agents/Scouts Payments<br/>
                            &nbsp;&nbsp;- Conferences<br/>
                            &nbsp;&nbsp;- Miscellaneous Charges<br/>
                            &nbsp;&nbsp;- Data available starting January 2018<br/><br/>
                            &nbsp;&nbsp;If you're looking up large amounts of data, please wait for the report to load.<br/><br/>
                            &nbsp;&nbsp;If your search is not successful (i.e. system crashes), try a shorter date range.
                            
                        </div>
                            <form onSubmit={handleSubmit}>
                                <fieldset style={{border:0, padding: 0, margin: 0}}>
                                    
                                  
                                    <div className="sales-report-byproduct-flex">
                                        <div>
                                            <label>Products:</label>
                                            <select 
                                            name="courses" 
                                                        size="15" 
                                                        className="form-select"
                                                        multiple
                                                        onChange={handleCoursesChange}
                                                        value={formData.courses}
                                            >
                                              { Object.keys(courseList).length > 0 && (
                                                    <>
                                                        { Object.keys(courseList).map((key) => {
                                                            return <>
                                                              
                                                                    <option value={key}>{courseList[key]}</option>
                                                                
                                                            </>
                                                        })}  
                                                    </>
                                                )}
                                            </select>
                                            <div style={{marginTop:"2%"}}>*To select more than one product, hold the Command/Ctrl key and click on as many as you want.</div>
                                        </div>
                                        
                                        <div style={{marginLeft:"30px"}}>
                                         <label htmlFor="pay_start_date">Payment Start Date:</label>
                                           
                                              <DatePicker
                                              ref={startDateRef}
                                                selected={formData.start_date_obj}
                                                onChange={(date) => {handleDateChange(date, 'start_date');
                                                  setTimeout(() => {
                                                            const input = startDateRef.current?.input;
                                                            if (input) {
                                                              const len = input.value.length;
                                                              input.setSelectionRange(len, len);
                                                            }
                                                          }, 0);
                                                }}
                                                name="start_date"
                                                id="pay_start_date"
                                                // required
                                            /> 
                                               {formErrors.start_date && (
                                            <div className="error">{formErrors.start_date}</div>
                                            )}
                                            <br /><br />
                                            <label htmlFor="pay_end_date">Payment End Date:</label>
                                          
                                              <DatePicker
                                              ref={endDateRef}
                                                selected={formData.end_date_obj}
                                                onChange={(date) => {handleDateChange(date, 'end_date');
                                                  setTimeout(() => {
                                                            const input = endDateRef.current?.input;
                                                            if (input) {
                                                              const len = input.value.length;
                                                              input.setSelectionRange(len, len);
                                                            }
                                                          }, 0);
                                                }}
                                                name="end_date"
                                                id="pay_end_date"
                                                // required
                                            />
                                            	  {formErrors.end_date && (
                                    <div className="error">{formErrors.end_date}</div>
                                    )}
                                            <br /><br />
                                        <div>
                                           <label htmlFor="pay">Payment Method</label>
                                     <select id="pay" name="payment_method" className="sales-report-byproduct-formselect" 
                                   value= {formData.payment_method} 
                                   onChange={handleChange}
                                     >
                                <option value="All">All</option>
                                <option value="sezzle">Sezzle</option>
                                <option value="authnet_aim">Credit Card</option>
                                <option value="paypal_wps">Paypal</option>
                                    </select><br /><br />
                                           
                                         		
                                        </div>
                                        <div>
                                            <input type="submit" name="" value="submit" className="form-submit" style={{marginRight:"12px"}} />
                                            <input type="button" name="" value="export" className="form-submit" style={{marginRight:"12px"}}  onClick={handleExport} />
                                             <button className='form-submit' type="button"
                                            onClick={handleReset}
                                                >clear</button>
                                        </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </form>
                             {submittedData && (
                                <>
                            <div className="totals-container">
                                <div id="total_apps"style={{padding: "12px", marginRight:"20px"}}>Total Shipping Amount: {totalShipAmount}</div>
                                <div id="total_apps"style={{padding: "12px", marginRight:"20px"}}>Total Sales Amount: {totalSaleAmount}</div>
                                <div id="total_apps"style={{padding: "12px", marginRight:"20px"}}>Total Amount Paid: {totalAmount}</div>
                                <div id="total_apps" style={{padding: "17px", marginRight:"20px"}}>Total Apps: {rowCount}</div>
                            </div>
        

                            <div className="sales-report-byproduct-popupdata">
                                <div className="sales-report-byproduct-content">
                                    <table className="sales-report-byproduct-table">
                                        <div>
                                            <DataGrid
                                                rows={rows}
                                                columns={columns}
                                                rowCount={rowCount}
                                                paginationMode="server"
                                                sortingMode="server"
                                                filterMode="server"
                                                paginationModel={paginationModel}
                                                onPaginationModelChange={setPaginationModel}
                                                sortModel={sortModel}
                                                onSortModelChange={setSortModel}
                                                filterModel={filterModel}
                                                onFilterModelChange={setFilterModel}
                                                pageSizeOptions={[5, 10, 25,50]}
                                                getRowId={() => crypto.randomUUID()}
                                                getRowHeight={() => 'auto'}
                                                disableColumnFilter 
                                                // disableColumnResize={true}
                                            />
                                        </div>
                                    </table>
                                </div>
                            </div>
                      </>
)}
                        </div>
                    </div>
                    <div className="right"></div>
                </div>
            )}
        </>
    );
};
export default SalesReportByProduct;